import mapItemsToTemplates from './mapItemsToTemplates';

/**
 * Returns a callback that appends given items.
 * @param {Element} component
 * @param {jQuery} $templates
 * @return {Function} A callback function
 */
const handleItemsAppend = (component, $templates) => (e, items) => {
    const wrappedItems = mapItemsToTemplates(items, $templates);

    // update DOM
    $(component).find('.grid').append(wrappedItems);
    // update masonry instance
    $(component).data('masonry').appended(wrappedItems);
};

export default handleItemsAppend;



// WEBPACK FOOTER //
// ./src/scripts/components/masonry/handleItemsAppend.js